import React, { useCallback, useEffect, useState } from "react";

import { useDispatch, useSelector } from "react-redux";
import Vehicle from "./Vehicle";
import _ from "underscore";
import SearchInput from "../../SearchInput";
import TabContentBody from "../../layouts/TabContentBody/TabContentBody";
import { TabsLayoutService } from "../../../services/tabslayout.service";
import Collapsible from "react-collapsible";

const GroupName = ({ name, totalVehicles, id, index }) => {
  return (
    <div style={{ padding: 7 }}>
      <i className="fa fa-th mr-2 ml-1"></i>
      <span className="group-name">{name}</span>
      <span className="float-right" style={{ marginRight: 25 }}>
        {totalVehicles}
      </span>
    </div>
  );
};

const VehicleGroup = (props) => {
  const _g = useSelector((state) => state.settingReducer.groups);
  const storage = useSelector((state) => state.settingReducer.vehiclesStorage);
  // const filter = useSelector((state) => state.groupReducer.activeFilter);
  const [groups, setGroups] = useState([]);
  const [vehicleStorage, setVehicleStorage] = useState([]);

  const __filter__ = useCallback(() => {
    var gp = JSON.parse(JSON.stringify(_g));
    var allGRP = [];

    gp.map((group) => {
      if (isSearchOn !== "") {
        group.vehicles = _.filter(group.vehicles, (v) =>
          v.name.match(new RegExp(isSearchOn, "gi"))
        );
      }

      if (group.vehicles.length !== 0) {
        allGRP.push(group);
      }
    });

    return allGRP;
  });

  const [isSearchOn, setIsSearchOn] = useState("");

  const handleSearch = useCallback((event) => {
    var value = event.target.value;
    setIsSearchOn(value);
  });

  const clear = () => {
    setIsSearchOn("");
  };

  useEffect(() => {
    setGroups(__filter__());
  }, [_g, isSearchOn]);

  useEffect(() => {
    setVehicleStorage(storage);
  }, [storage]);

  // CHANGE LAYOUT HEIGHT
  useEffect(() => {
    TabsLayoutService.changeFooterHeight(135);

    return () => {
      TabsLayoutService.changeFooterHeight(50);
    };
  }, []);

  const renderContent = () => {
    return (
      <div className="group-list group-list-scroll max-100">
        <div className="tab-container">
          {groups.map((group, i) => (
            <Collapsible
              key={group.id}
              open={true}
              trigger={
                <GroupName
                  index={i}
                  name={group.name}
                  id={group.id}
                  totalVehicles={Object.keys(group.vehicles).length}
                />
              }
              transitionTime={100}
            >
              {group.vehicles.map((vehicle, i) => (
                <Vehicle
                  activeVehicle={props.activeVehicle}
                  onVehicleSelected={props.onVehicleSelected}
                  key={i}
                  vehicle={vehicle}
                  totalUsedStorage={vehicleStorage[vehicle.id]}
                  totalVehiclesStorage={props.totalUsed}
                />
              ))}
            </Collapsible>
          ))}

          {groups.length == 0 && isSearchOn !== "" && (
            <div className="text-center">
              <span className="font-12 gray">No vehicles found</span>
            </div>
          )}
        </div>
      </div>
    );
  };

  const renderFooter = () => {
    return (
      <div className="footer-search mb-1" style={{ height: "40px" }}>
        <SearchInput
          onSearch={handleSearch}
          placeholder="Search..."
          value={isSearchOn}
          text={isSearchOn}
          onClear={clear}
        />
      </div>
    );
  };

  return <TabContentBody content={renderContent()} footer={renderFooter()} />;
};

export default VehicleGroup;
